import React, { Component } from 'react';

class CourseItem extends Component {
  render() {
    return (
      <div>
        <div      
          className="course-card"
        >
          <p style={styles.courseNumber}>{this.props.department + " " + this.props.number}</p>
          <div>
            <h2 style={styles.courseName}>{this.props.name}</h2>
            <p style={styles.description}>{this.props.description}</p>
          </div>
            <div style={styles.iconWrapper}>
              <img alt={"Course Icon"}src={this.props.icon} style={styles.icon}/>
            </div>
        </div>
      </div>
    );
  }
}

const styles = {
  courseCard: {
    marginBottom: 10,
    marginRight: 16,
    width: 250,
    height: 300,
    padding: 10,
    borderRadius: 15,
    justifyContent: 'flex-start',
    backgroundColor: '#F7F7F7',
    position: 'relative',
    boxShadow: '-1px 2px 36px -13px rgba(0, 0, 0, 0.7)',
  },
  courseNumber:{
    fontSize: 14,
    textAlign: 'start',
    letterSpacing: '2.5px',
    marginBottom: '0px',
    width: '100%'
  },
  courseName: {
    fontSize: 24,
    textAlign: 'start'
  },
  description:{
    fontSize: 12,
    textAlign: 'start'
  },
  icon:{
    height: 40,
    width: 40,
  },
  iconWrapper:{
    height: 40,
    width: 40,
    position: 'absolute',
    bottom: 20,
    right: 16,
  }
}
export default CourseItem;



// WEBPACK FOOTER //
// ./src/components/CourseItem.js